/**
 * Новая система (новый учёт и трекер) пока только бэкап Яндекс Трекера: показываем данные,
 * но ничего в ней не пишем. Запись включается сборкой с `VITE_V2_WRITE_ENABLED=true` —
 * когда Яндекс Трекер перестанет работать. Без переменной запись выключена
 */
export const IS_V2_WRITE_ENABLED = import.meta.env.VITE_V2_WRITE_ENABLED === 'true';

export const V2_READ_ONLY_MESSAGE = 'Новая система сейчас только для просмотра';
